module.exports = __webpack_public_path__ + "img/loading.633d107f.gif";